import React, { useState, useMemo } from "react";
import Chart from "react-apexcharts";
import "./InsightPreview.scss";
import Trend from "../../../assets/images/trend.png";
import Breakup from "../../../assets/images/breakup.png";
import DandD from "../../../assets/images/dandd.png";
import Word from "../../../assets/images/word.png";
/* ---------- Random helpers ---------- */
const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

/* ---------- Chart Generators ---------- */
const getScoreBreakup = () => ({
    series: [
        {
            data: [
                rand(10, 30),
                rand(10, 30),
                rand(10, 30),
                rand(10, 30),
                rand(10, 30)
            ]
        }
    ],
    options: {
        chart: { type: "bar", height: 250 },
        plotOptions: {
            bar: { distributed: true, borderRadius: 4 }
        },
        colors: ["#52c41a", "#a0d911", "#fadb14", "#fa8c16", "#ff4d4f"],
        xaxis: {
            categories: ["Excellent", "Good", "Average", "Poor", "Very Poor"]
        }
    }
});

const getTrend = () => ({
    series: [
        { name: "Score", type: "line", data: Array.from({ length: 6 }, () => rand(40, 80)) },
        { name: "Responses", type: "column", data: Array.from({ length: 6 }, () => rand(10, 60)) }
    ],
    options: {
        chart: { height: 260, type: "line" },
        stroke: { width: [3, 0] },
        xaxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
        colors: ["#2563eb", "#93c5fd"]
    }
});

const getReasons = () => ({
    series: [rand(10, 40), rand(10, 40), rand(10, 40), rand(10, 40)],
    options: {
        chart: { type: "donut" },
        labels: ["Service", "Delivery", "Pricing", "Support"],
        colors: ["#2563eb", "#52c41a", "#fadb14", "#fa8c16"]
    }
});

const getDriversDraggers = () => ([
    { label: "Leadership", value: 85, color: "success" },
    { label: "Communication", value: 70, color: "success" },
    { label: "Team Support", value: 50, color: "warning" },
    { label: "Workload", value: 35, color: "danger" },
    { label: "Process Clarity", value: 43, color: "danger" }
]);



const getResponseTracker = () => ({
    series: [{ data: Array.from({ length: 5 }, () => rand(20, 80)) }],
    options: {
        chart: { type: "bar", height: 240 },
        colors: ["#2563eb"],
        plotOptions: {
            bar: { borderRadius: 4 }
        },
        xaxis: {
            categories: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"]
        }
    }
});

const getWordCloud = () => [
    "Great",
    "Slow",
    "Excellent",
    "Helpful",
    "Bad",
    "Amazing",
    "Supportive",
    "Poor",
    "Fast",
    "Friendly"
].sort(() => 0.5 - Math.random()).slice(0, 7);

/* ---------- MAIN COMPONENT ---------- */

const InsightTabs = ({ tabs = [] }) => {
    const [active, setActive] = useState(tabs[0]?.key);

    const content = useMemo(() => {
        switch (active) {
            case "break_up":
                return getScoreBreakup();
            case "trend":
                return getTrend();
            case "reasons":
                return getReasons();
            case "drivers_and_draggers":
                return getDriversDraggers();
            case "response_tracker":
                return getResponseTracker();
            case "sentiments":
            case "googlereview":
                return getWordCloud();
            default:
                return null;
        }
    }, [active]);

    return (
        <div className="tabs-card">

            {/* Tabs header */}
            <div className="tab-header">
                <div className="tab-header tab-scroll">
                    {tabs.map(tab => (
                        <button
                            key={tab.key}
                            className={`tab-btn ${active === tab.key ? "active" : ""}`}
                            onClick={() => setActive(tab.key)}
                        >
                            {tab.label || tab.key}
                        </button>
                    ))}
                </div>
            </div>

            {/* Tabs content */}
            <div className="tab-content">

                {/* Score Breakup */}
                {active === "break_up" && (
                    // <Chart
                    //     options={content.options}
                    //     series={content.series}
                    //     type="bar"
                    //     height={250}
                    // />
                    <img alt="" src={Breakup} className="dashboard-preview-img w-100" />
                )}

                {/* Trend */}
                {active === "trend" && (
                    // <Chart
                    //     options={content.options}
                    //     series={content.series}
                    //     type="line"
                    //     height={260}
                    // />
                    <img alt="" src={Trend} className="dashboard-preview-img w-100" />
                )}

                {/* Reasons */}
                {active === "reasons" && (
                    <Chart
                        options={content.options}
                        series={content.series}
                        type="donut"
                        height={260}
                    />
                )}

                {/* Drivers & Draggers */}
                {active === "drivers_and_draggers" && (
                    <div className="drivers-draggers-wrapper">
                        <img alt="" src={DandD} className="dashboard-preview-img w-100" />
                        {/* 🔹 Header with radio options */}
                        {/* <div className="drivers-header">
                            <label className="text-success">
                                <input type="radio" name="dd-filter" defaultChecked /> Drivers
                            </label>
                            <label className="text-warning">
                                <input type="radio" name="dd-filter" /> Average
                            </label>
                            <label className="text-danger">
                                <input type="radio" name="dd-filter" /> Draggers
                            </label>
                        </div> */}

                        {/* 🔹 Progress bars */}
                        {/* {content.map(item => (
                            <div key={item.label} className="progress-item">
                                <div className="d-flex justify-content-between mb-1">
                                    <span>{item.label}</span>
                                    <span>{item.value}</span>
                                </div>

                                <div className="progress">
                                    <div
                                        className={`progress-bar bg-${item.color}`}
                                        style={{ width: `${item.value}%` }}
                                    />
                                </div>
                            </div>
                        ))} */}
                    </div>
                )}

                {/* Response Tracker */}
                {active === "response_tracker" && (
                    <Chart
                        options={content.options}
                        series={content.series}
                        type="bar"
                        height={240}
                    />
                )}

                {/* Sentiments & Google Review */}
                {(active === "sentiments" || active === "googlereview") && (
                    <img alt="" src={Word} className="dashboard-preview-img w-100" />
                    // <div className="word-cloud">
                    //     {content?.map(word => (
                    //         <span
                    //             key={word}
                    //             style={{ fontSize: rand(14, 28), color: 'black' }}
                    //         >
                    //             {word}
                    //         </span>
                    //     ))}
                    // </div>
                )}

            </div>
        </div>
    );
};

export default InsightTabs;